/*
 * Copyright (c) 2021. American Express Company
 */

import { ProgressBarViewModel } from 'src/types/view-models/progress-bar.view.model';

export default class ProgressService {
    public static getBarWidth(progress: ProgressBarViewModel): string {
        const range: number = progress.max - progress.min;
        const percentage: number = Math.round((progress.current / range) * 100);

        return `${percentage}%`;
    }
}
